import { useWindowManager } from "../../context/WindowContext";
import { WINDOWS } from "../../data/windows";
import { useDesktopIcons } from "../../hooks/useDesktopIcons";
import classes from "./Icons.module.css";

const DESKTOP_WINDOWS = WINDOWS.filter(
  (window) => window.showOnDesktop !== false
);

export const Icons = () => {
  const { open } = useWindowManager();
  const {
    desktopRef,
    positions,
    selectedIds,
    marquee,
    draggingIds,
    setIconRef,
    onDesktopPointerDown,
    onIconPointerDown,
    onIconDoubleClick,
  } = useDesktopIcons(open);

  const showMarquee = marquee && (marquee.width > 2 || marquee.height > 2);

  return (
    <div
      ref={desktopRef}
      className={classes.Icons}
      onPointerDown={onDesktopPointerDown}
    >
      {DESKTOP_WINDOWS.map((window) => {
        const position = positions[window.id];
        const selected = selectedIds.includes(window.id);
        const dragging = draggingIds.includes(window.id);

        return (
          <div
            key={window.id}
            ref={setIconRef(window.id)}
            className={[
              classes.icon,
              selected ? classes.selected : null,
              dragging ? classes.dragging : null,
            ]
              .filter(Boolean)
              .join(" ")}
            style={{
              left: position?.x ?? 0,
              top: position?.y ?? 0,
            }}
            onPointerDown={(event) => onIconPointerDown(event, window.id)}
            onDoubleClick={(event) => onIconDoubleClick(event, window.id)}
            onDragStart={(event) => event.preventDefault()}
          >
            <img src={window.icon} alt={window.iconAlt} draggable={false} />
            <p>{window.desktopLabel}</p>
          </div>
        );
      })}
      {showMarquee ? (
        <div
          className={classes.marquee}
          style={{
            left: marquee.x,
            top: marquee.y,
            width: marquee.width,
            height: marquee.height,
          }}
        />
      ) : null}
    </div>
  );
};
